import React from 'react'
import PropTypes from 'prop-types'

import Money from '@cred/react-basic-form-fields/hookForm/Money'
import Dropdown from '@cred/react-basic-form-fields/hookForm/Dropdown'

import Footer from 'multi-vertical/rate-table/components/filter-modal/footer'
import renderDropdownOptions from 'utils/renderDropdownOptions'

import styles from './styles.module.scss'

const options = [
  { value: '850', label: 'Excellent (750+)' },
  { value: '749', label: 'Good (700-749)' },
  { value: '699', label: 'Fair (640-699)' },
  { value: '639', label: 'Poor (<640)' },
]
const noop = () => {}

/* eslint-disable indent */
const FilterForm = ({
  update = noop,
  cancel = noop,
  invalid = false,
  withFooter = false,
  customValidation = [],
  className = '',
  control,
}) => {
  return (
    <div className={className}>
      <div className={styles.filters}>
        <Money
          id="loanAmount"
          name="loanAmount"
          label="Loan Amount"
          placeholder="Loan amount"
          control={control}
          controllerProps={{ rules: { validate: { ...customValidation } } }}
          exposeValue
        />
        <Dropdown
          id="creditScoreApprox"
          name="creditScoreApprox"
          label="Estimated Credit Score"
          placeholder="Estimated credit score"
          control={control}
        >
          {renderDropdownOptions(options)}
        </Dropdown>
      </div>
      {withFooter && <Footer cancel={cancel} invalid={invalid} update={update} />}
    </div>
  )
}

FilterForm.propTypes = {
  update: PropTypes.func,
  cancel: PropTypes.func,
  invalid: PropTypes.bool,
  withFooter: PropTypes.bool,
  customValidation: PropTypes.array,
  className: PropTypes.string,
  control: PropTypes.object.isRequired,
}

export { FilterForm as FilterFormNoHoc }

export default FilterForm
